import React, { useState, useEffect } from "react";
import { auth } from "./firebase";
import { 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword, 
  signOut, 
  sendPasswordResetEmail,
  GoogleAuthProvider,
  signInWithPopup
} from "firebase/auth";

export function LoginModal({ isOpen, onClose, user, initialMode = "login" }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isRegister, setIsRegister] = useState(initialMode === "register");
  const [showWelcome, setShowWelcome] = useState(false);
  
  // Diese Logik prüft beim Öffnen, ob der User über den Invite-Link kommt
  useEffect(() => {
    if (!isOpen) return;
  
    const params = new URLSearchParams(window.location.search);
    const isInviteLink = params.get("invite") === "true";
  
    if (isInviteLink) {
      // Invite-Link hat Priorität
      setIsRegister(true);
      setShowWelcome(true);
    } else {
      // Normaler Login/Register Modus
      setIsRegister(initialMode === "register");
      setShowWelcome(false);
    }
  }, [isOpen, initialMode]);

  const handleAuth = async () => {
    try {
      if (isRegister) await createUserWithEmailAndPassword(auth, email, password);
      else await signInWithEmailAndPassword(auth, email, password);
      onClose();
    } catch (err) { alert(err.message); }
  };

  const handleGoogle = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
      onClose();
    } catch (err) { alert(err.message); }
  };

  if (!isOpen) return null;

  return (
    <div style={{ 
      position: "fixed", 
      top: 0, 
      left: 0, 
      width: "100%", 
      height: "100%", 
      background: "rgba(0,0,0,0.85)", 
      display: "flex", 
      alignItems: "center", // Zentriert auf Desktop
      justifyContent: "center", 
      zIndex: 3000, 
      padding: "15px",      // Kleinerer Puffer für Mobile
      boxSizing: "border-box",
      overflowY: "auto"     // Erlaubt Scrollen, wenn die Tastatur offen ist
    }}>
      <div style={{ 
        background: "#1a1f2b", 
        padding: "25px",    // Leicht reduziert für mehr Platz
        borderRadius: "20px", 
        width: "100%", 
        maxWidth: "400px", 
        position: "relative", 
        border: "1px solid #2d3446",
        boxSizing: "border-box",
        margin: "auto"      // Wichtig für Scroll-Verhalten in Flexbox
      }}>
        
        <button onClick={onClose} style={{ position: "absolute", top: "15px", right: "15px", background: "none", border: "none", color: "#fff", fontSize: "1.2rem", cursor: "pointer", zIndex: 10 }}>✕</button>
        
        {/* NEU: WILLKOMMENS-BOX FÜR ARTISTS */}
        {showWelcome && !user && (
          <div style={{ 
            background: "#00acc1", // Dein Marken-Cyan
            padding: "20px", 
            borderRadius: "15px", 
            marginBottom: "20px", 
            color: "#000",
            textAlign: "left"
          }}>
            <h3 style={{ marginTop: 0, fontSize: "1rem", fontWeight: "900" }}>WILLKOMMEN IM COLLECTIVE!</h3>
            <p style={{ fontSize: "0.85rem", lineHeight: "1.4", margin: "10px 0" }}>
              Lieber Music Artist. Willkommen im streetwise RADIO Collective Studio. Damit du eigene Tracks uploaden kannst, musst du zuerst hier deinen persönlichen Artist Account erstellen.
            </p>
            <button 
              onClick={() => setShowWelcome(false)}
              style={{ background: "#000", color: "#fff", border: "none", padding: "8px 15px", borderRadius: "5px", fontSize: "0.75rem", fontWeight: "bold", cursor: "pointer" }}
            >
              JETZT ACCOUNT ERSTELLEN →
            </button>
          </div>
        )}

        <h2 style={{ color: "#fff", marginBottom: "25px", fontSize: "1.6rem", textAlign: "left" }}>
            {user ? "Account" : (isRegister ? "Neuen Account erstellen" : "Login")}
        </h2>

        {user ? (
          <div style={{ textAlign: "center" }}>
            <p style={{ color: "#fff", marginBottom: "20px" }}>Logged in as:<br/>{user.email}</p>
            <button onClick={() => signOut(auth)} style={{ width: "100%", padding: "12px", background: "#4a3aff", color: "#fff", border: "none", borderRadius: "10px", fontWeight: "bold", cursor: "pointer" }}>LOGOUT</button>
          </div>
        ) : (
          <>
            <div style={{ marginBottom: "15px", textAlign: "left" }}>
              <label style={{ color: "#888", fontSize: "0.8rem", display: "block", marginBottom: "8px" }}>Email</label>
              <input 
                style={{ width: "100%", padding: "12px", borderRadius: "10px", border: "1px solid #3d4454", background: "#fff", color: "#000", boxSizing: "border-box" }} 
                value={email} 
                onChange={e => setEmail(e.target.value)} 
                type="email"
              />
            </div>

            <div style={{ marginBottom: "25px", textAlign: "left" }}>
              <label style={{ color: "#888", fontSize: "0.8rem", display: "block", marginBottom: "8px" }}>Password</label>
              <input 
                type="password" 
                style={{ width: "100%", padding: "12px", borderRadius: "10px", border: "1px solid #3d4454", background: "#fff", color: "#000", boxSizing: "border-box" }} 
                value={password} 
                onChange={e => setPassword(e.target.value)} 
              />
            </div>

            <button onClick={handleAuth} style={{ width: "100%", padding: "15px", background: "#4a3aff", color: "#fff", border: "none", borderRadius: "10px", fontWeight: "bold", fontSize: "1rem", cursor: "pointer", marginBottom: "15px" }}>
              {isRegister ? "Create Account" : "Login"}
            </button>

            <button onClick={handleGoogle} style={{ width: "100%", padding: "12px", background: "#fff", color: "#000", border: "1px solid #ddd", borderRadius: "10px", fontWeight: "bold", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", marginBottom: "20px" }}>
              <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" width="18" alt="G" /> Sign in with Google
            </button>

            <div style={{ textAlign: "center", fontSize: "0.8rem" }}>
              <span onClick={() => setIsRegister(!isRegister)} style={{ color: "#00acc1", cursor: "pointer" }}>
                {isRegister ? "Already have an account? Login" : "Don't have an account? Sign up"}
              </span>
              <br/><br/>
              {!isRegister && (
                <span onClick={async () => {
                  if (!email) {
                    alert("Bitte zuerst deine Email-Adresse eingeben.");
                    return;
                  }
                  try {
                    await sendPasswordResetEmail(auth, email);
                    alert("Reset-Link gesendet! Prüfe dein Email-Postfach.");
                  } catch (err) {
                    if (err.code === "auth/user-not-found") {
                      alert("Keine Account mit dieser Email gefunden.");
                    } else {
                      alert("Fehler: " + err.message);
                    }
                  }
                }} style={{ color: "#555", cursor: "pointer" }}>
                  Forgot Password?
                </span>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}